// src/components/common/SeoWrapper.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import SEO from './SEO';
import seoData from 'utils/constants/seoData';

const getMemberType = (pathname) => {
  const segments = pathname.split('/');
  return segments[1] || 'common';
};

const getPageKeyFromPath = (pathname) => {
  if (pathname.includes('/career-support/15/15')) return 'careerOpportunities';
  if (pathname.includes('/career-support/6/6')) return 'careerSupport';
  if (pathname.includes('/chapters-groups/chapters')) return 'chapters';
  if (pathname.includes('/conferences-and-events/event-list/conference')) return 'conference';
  if (pathname.includes('/dashboard')) return 'dashboard';
  if (pathname.includes('/digital-library')) return 'digitalLibrary';
  if (pathname.includes('/sig-groups')) return 'chaptersSigGroups';
  if (pathname.includes('/scopus-indexed-journals'))
    return 'scopusIndexedJournals';
  if (pathname.includes('/upgrade')) return 'upgradeMembership';
  if (pathname.includes('/apply-for-committee-member'))
    return 'committeeMember';
  if (pathname.includes('/member/register')) return 'memberRegister';
  if (pathname.includes('/member/login')) return 'memberLogin';
  return 'homepage';
};

const SEOWrapper = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const memberType = getMemberType(pathname);
  const pageKey = getPageKeyFromPath(pathname);
  const seo = seoData?.[memberType]?.[pageKey] || seoData?.common?.[pageKey];

  if (!seo) return null;

  return (
    <SEO
      title={seo.title}
      description={seo.description}
      canonical={seo.canonical}
    />
  );
};

export default SEOWrapper;
